module.exports = __webpack_public_path__ + "img/yufukuan.0ce37d72.png";